import messages from './borrar-app-modal-translations';
import * as $ from 'jquery';
import { BorrarAppService } from './services/borrarAppService';

export default {
    name: 'instamapsBorrarAppModal',
    i18n: {
        messages,
    },
    props: {
        delay: { type: Number },
        isError: { type: Boolean },
        isLoaded: { type: Boolean },
        mapa: { type: Object },
    },
    methods: {
        show: function () {
            setTimeout(function () {
                $('#borrar-app-modal').addClass('animate-flex-modal');
            }, (this.delay) ? this.delay : 100);
        },
        dismiss: function () {
            $('#borrar-app-modal').removeClass('animate-flex-modal');
            this.$emit('loaded');
        },
        borrarApp: function(){
            BorrarAppService.deleteApp(this.mapa.businessId, this.mapa.eliminar).then((response) => {
                if (response.status==="OK") {
                    this.$emit('deleteApp', {businessId: this.mapa.businessId});
                    this.dismiss();
                }else{
                    this.dismiss();
                    this.$emit('error', {title: this.$t('title'), message: this.$t('messageError')});
                }
            }).catch(() => {
                this.dismiss();
                this.$emit('error', {title: this.$t('title'), message: this.$t('messageError')});
            });
        },
    },
    watch: {
        'isLoaded': function(val){
            if(val){
                this.show();
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/perfil/components/borrar-app-modal/borrar-app-modal.js